import * as React from "react";
import classNames from 'classnames';
import Cookies from 'js-cookie';
import { Frame } from "../../frame/frame-container";
import { WebChatHeader } from "../header/header";
import { WebChatContent } from "../content/content";
import { IInitialState, WebchatPosition, DataContext, ScreenView } from '../../..//models/chat.models';

export const ChatContainer = () => {
  
  const context: IInitialState = React.useContext(DataContext);

  const cssContainer = require('./chat-container.css').toString();
  const cssContainerIFrame = require('./chat-container-iframe.css').toString();
  const cssFrame = require('../../frame/frame-container.css').toString();

  let personalizedCss = '';

  if (context.webChatSettings && context.webChatSettings.WebchatPosition) {
    if (context.webChatSettings.WebchatPosition == WebchatPosition.Left) {
      personalizedCss = '\
      .help-desk-container .help-desk-messenger {\
        left: 20px; \
      }';
    }
    
    if (context.webChatSettings.WebchatPosition == WebchatPosition.Right) {
      personalizedCss = '\
      .help-desk-container .help-desk-messenger {\
        right: 20px; \
      }';
    }

    if (context.webChatSettings.WebchatPosition == WebchatPosition.Middle) {
      personalizedCss = '\
      .help-desk-container .help-desk-messenger {\
        right: 50%; \
        transform: translateX(50%); \
      }';
    }

    if (context.webChatSettings.WebchatPosition == WebchatPosition.Draggable) {
      personalizedCss = '\
      .help-desk-container .help-desk-messenger {\
        right: 0px; \
      }';
    }
  } else {
    personalizedCss = '\
      .help-desk-container .help-desk-messenger {\
        right: 20px; \
      }';
  }

  if (context.webchatHeight > 0) {
    personalizedCss = personalizedCss + '\
      .help-desk-container .help-desk-messenger {\
        height: ' + context.webchatHeight +'px; \
      }';
  }

  function getLanguage(): string {
    if (context.webChatDto && context.webChatDto.Lang) {
      return context.webChatDto.Lang;
    } else {
      let lang = Cookies.get("lang");
      if (lang) {
        return lang;
      } else {
        return "";
      }
    }
  }

  return (
    <div>
      <style>
        {cssContainer}
        {personalizedCss}
      </style>
      <div className="help-desk-messenger">
        <Frame name="help-desk-messenger-frame">
          <style>
            {cssFrame}
            {cssContainerIFrame}
          </style>
          <link rel="stylesheet" href="/css/webchat.css" />
          {
            context.webChatSettings.CssUrl != '' && context.webChatSettings.CssUrl != null ? <link rel="stylesheet" href={context.webChatSettings.CssUrl} /> : <style></style>
          }
          <div id="help-desk-container"
            className={classNames('help-desk-container', { 'help-desk-container-welcome': context.screenView == ScreenView.Welcome }
              , { 'help-desk-container-chat': context.screenView == ScreenView.Chat }, { 'webchat-draggable-container': context.webChatSettings.WebchatPosition == WebchatPosition.Draggable }
            )}
            role="main" aria-live="polite">
            <div role="region">
              <div>
                <div className="help-desk-messenger help-desk-messenger-conversation help-desk-messenger-from-conversations">
                  
                  <WebChatHeader />
                  <WebChatContent />

                </div>
              </div>
            </div>
          </div>
        </Frame>
      </div>
    </div>
  )
}